export const clean = (items: string[]) => {
  return items.filter((item) => item !== null && item !== 'null' && item !== undefined && item !== 'undefined' && item !== '');
};
